import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./Components/Home/Home";
import AboutPage from "./Components/About/About";
import ProductPage from "./Components/ProductPage/ProductPage";
import CommitmentPage from "./Components/CommitmentPage/CommitmentPage";
import ContactPage from "./Components/ContactPage/ContactPage";
import SuperbGallery from "./Components/Gallery/Gallery";
import ProductDetail from "./Components/ProductDetail/ProductDetail";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";

// Admin Imports

import AdminCategory from "./Admin/AddCategory/AdminCategory";
import AdminSettings from "./Admin/ChangePassword/AdminSettings";
import AdminLayout from "./Admin/AdminSidebar/AdminLayout";
import AdminLogin from "./Admin/AdminLogin/AdminLogin";
import AdminItem from "./Admin/AdminItem/AdminItem";
import AdminSlider from "./Admin/AddSlider/AdminSlider";
import AdminGallery from "./Admin/AdminGallery/AdminGallery";
import AdminInquiries from "./Admin/AdminInquiries/AdminInquiries";
import NotFound from "./Components/NotFound/NotFound";
import AdminTrade from "./Admin/AdminTrade/AdminTrade";
import TradePage from "./Components/TradePage/TradePage";
import ScrollToTop from "./ScrollToTop";


// --- PROTECTED ROUTE COMPONENT ---
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

// --- WRAPPER TO HIDE NAV/FOOTER ON ADMIN PAGES ---
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  // Don't show public Navbar/Footer on any path starting with /admin
  const isAdminPath = location.pathname.startsWith('/admin') || location.pathname === '/admin-login';

  return (
    <>
      {!isAdminPath && <Navbar />}
      {children}
      {!isAdminPath && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
       <ScrollToTop /> 
      <LayoutWrapper>
        <Routes>
          {/* --- PUBLIC WEBSITE ROUTES --- */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/product/:catId" element={<ProductPage />} />
          <Route path="/commitments" element={<CommitmentPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/gallery" element={<SuperbGallery />} />
          <Route path="/trade" element={<TradePage />} />

          <Route path="/product-detail/:id" element={<ProductDetail />} />

          {/* --- ADMIN AUTH --- */}
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="*" element={<NotFound />} />

          {/* --- PROTECTED ADMIN PANEL ROUTES --- */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            {/* These load inside the AdminLayout's <Outlet /> */}
            <Route index element={<Navigate to="/" />} />
     <Route path="additem" element={<AdminItem />} />
     <Route path="addslider" element={<AdminSlider />} />
 <Route path="addgallery" element={<AdminGallery />} />
            <Route path="category" element={<AdminCategory />} />
            <Route path="changepassword" element={<AdminSettings />} />
 <Route path="inquiries" element={<AdminInquiries />} />
 <Route path="trade" element={<AdminTrade />} />

          </Route>

        
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;